import React, { Fragment, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { apiJson } from "../../api/Api";
import { ClipLoader } from "react-spinners";
import "./forgetmodal.scss";
import { getRandomInt } from "../../utils/utils";

const emailValidation = Yup.object().shape({
  email: Yup.string().email().required("Required"),
});

const ForgetModal = (props) => {
  const [changing, setChanging] = useState(false);
  const emailValues = {
    email: "",
  };

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const changePass = (values) => {
    setChanging(true);
    apiJson.auth.resetPassEmail({ email: values.email }).then((response) => {
      setChanging(false);
      if (response.success) {
        message = "Verification has been sent to your email address";
        showSuccess();
        props.onClose();
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  };

  return (
    <Fragment>
      <div className="forget-modal">
        <div className="header-row w-100 d-flex justify-content-between align-items-center">
          <div className="close-col" onClick={props.onClose}>
            <GrFormClose />
          </div>
        </div>
        <Formik
          initialValues={emailValues}
          validationSchema={emailValidation}
          enableReinitialize
          onSubmit={(values) => changePass(values)}
        >
          {({ errors, touched }) => (
            <Form>
              <div className="boday-row w-100">
                <div className="title-row">{props.title}</div>
                <div className="guide-text-row">
                  Enter your email address and we'll send you a link to reset
                  your password
                </div>
                <div className="input-row">
                  <div className="label">Email</div>
                  <Field type="email" name="email" className="email-input" />
                  {touched.email && errors.email && (
                    <div
                      className="error"
                      style={{ textAlign: "initial", color: "red" }}
                    >
                      {errors.email}
                    </div>
                  )}
                </div>
              </div>
              <div className="button-row w-100 d-flex align-items-center justify-content-center">
                <button
                  className="submit-button"
                  type="submit"
                  key={getRandomInt(1, 1000)}
                  disabled={changing}
                >
                  {changing ? (
                    <div className="d-flex justify-content-center align-items-center w-100">
                      <ClipLoader color="#000" loading size={25} />
                    </div>
                  ) : (
                    "Submit Email"
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Fragment>
  );
};

export default ForgetModal;
